import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { manageEmailSubscriptionEurW } from '../firebaseConfig';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    // Get email from URL parameter
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(decodeURIComponent(emailParam));
    }
    setInitialLoad(false);
  }, [searchParams]);

  const handleSubscriptionUpdate = async (action) => {
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const result = await manageEmailSubscriptionEurW({
        email: email,
        action: action,
      });

      if (result.data.success) {
        setIsSubscribed(action === 'subscribe');
        setMessage(result.data.message);
      } else {
        setError('Failed to update subscription. Please try again.');
      }
    } catch (err) {
      console.error('Subscription update error:', err);
      if (err.code === 'functions/not-found') {
        setError('User not found. Please check your email address.');
      } else if (err.code === 'functions/invalid-argument') {
        setError('Invalid email address. Please check and try again.');
      } else {
        setError('An error occurred. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '4rem 2rem', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: '600px', width: '100%' }}>
        <h1 className="section-title" style={{ marginBottom: '2rem', color: '#ffffff' }}>
          email subscription management
        </h1>

          <div
            style={{
              background: '#2A2429',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '12px',
              padding: '2rem',
            }}
          >
            <p style={{ color: '#ffffff', marginBottom: '2rem', lineHeight: '1.6' }}>
              Manage your email preferences for pplkpr updates, tips, and insights.
            </p>

            <div className="form-group" style={{ marginBottom: '2rem' }}>
              <label
                className="form-label"
                style={{ color: '#ffffff', marginBottom: '0.5rem', display: 'block' }}
              >
                email address
              </label>
              <input
                type="email"
                className="form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: '#1a1519',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: '#ffffff',
                  fontSize: '1rem',
                }}
                disabled={loading}
              />
            </div>

            {error && (
              <div
                style={{
                  background: 'rgba(255, 59, 48, 0.1)',
                  border: '1px solid rgba(255, 59, 48, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1.5rem',
                  color: '#ff3b30',
                }}
              >
                {error}
              </div>
            )}

            {message && (
              <div
                style={{
                  background: 'rgba(52, 199, 89, 0.1)',
                  border: '1px solid rgba(52, 199, 89, 0.3)',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1.5rem',
                  color: '#34c759',
                }}
              >
                {message}
              </div>
            )}

            <div
              style={{
                display: 'flex',
                gap: '1rem',
                flexDirection: 'column',
              }}
            >
              <button
                className="btn btn-primary"
                onClick={() => handleSubscriptionUpdate('unsubscribe')}
                disabled={loading || !email}
                style={{
                  width: '100%',
                  padding: '1rem',
                  background: isSubscribed ? '#ff3b30' : '#444',
                  opacity: loading || !email ? 0.5 : 1,
                  cursor: loading || !email ? 'not-allowed' : 'pointer',
                }}
              >
                {loading ? 'processing...' : 'unsubscribe from emails'}
              </button>

              <button
                className="btn btn-secondary"
                onClick={() => handleSubscriptionUpdate('subscribe')}
                disabled={loading || !email}
                style={{
                  width: '100%',
                  padding: '1rem',
                  background: isSubscribed ? '#444' : '#34c759',
                  opacity: loading || !email ? 0.5 : 1,
                  cursor: loading || !email ? 'not-allowed' : 'pointer',
                }}
              >
                {loading ? 'processing...' : 'subscribe to emails'}
              </button>
            </div>

            <p
              style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: '0.875rem',
                marginTop: '2rem',
                lineHeight: '1.6',
              }}
            >
              Note: It may take up to 24 hours for changes to take effect. You will only
              receive emails related to pplkpr features, insights, and important updates.
            </p>
          </div>

          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '1rem' }}>
              Need help? Contact us at{' '}
              <a
                href="mailto:contact@pplkpr.ai"
                style={{ color: '#007AFF', textDecoration: 'none' }}
              >
                contact@pplkpr.ai
              </a>
            </p>
          </div>
        </div>
      </div>
  );
};

export default Unsubscribe;
